var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNewWord(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09081 10H4.21081V7.632C4.21081 6.944 4.11481 6.2 4.05881 5.568H4.09881L4.69881 6.832L6.41081 10H7.61881V4.08H6.49081V6.44C6.49081 7.112 6.58681 7.904 6.65081 8.52H6.61081L6.01081 7.24L4.29081 4.08H3.09081V10ZM8.603 10H12.323V9.008H9.787V7.432H11.859V6.432H9.787V5.064H12.235V4.08H8.603V10ZM13.6049 10H15.0529L15.7009 7.072C15.7889 6.616 15.8769 6.152 15.9569 5.704H15.9889C16.0609 6.152 16.1409 6.616 16.2449 7.072L16.9009 10H18.3809L19.4769 4.08H18.3569L17.8769 6.968C17.7969 7.592 17.7009 8.224 17.6209 8.864H17.5809C17.4449 8.224 17.3329 7.584 17.2049 6.968L16.5169 4.08H15.5009L14.8209 6.968C14.6929 7.592 14.5649 8.224 14.4449 8.864H14.4129C14.3169 8.224 14.2289 7.592 14.1329 6.968L13.6689 4.08H12.4609L13.6049 10Z",
    fill: "#E7321A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewWord);
export default __webpack_public_path__ + "static/media/icon_new_word.f6c12a4cad13e8c02b5f20281066b18a.svg";
export { ForwardRef as ReactComponent };